export default function LoadingSpinner(props) {

    return(
        <div className="loading-spinner">
            <i className="loading-spinner-icon fa-solid fa-circle-notch"></i>
        </div>
    );
}